import type { DefaultDashboardDefinition } from './dashboard-definition';

export const organisationDashboard: DefaultDashboardDefinition = {
  id: "configuration.organisation",
  appId: "configuration",
  name: "Organisation dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: ".",
  },
  queryScope: null,
  placements: [
    {
      id: "organisation.record.employees.default",
      widgetId: "organisation.record.employees",
      placement: {
        x: 0,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "organisation.record.branches.default",
      widgetId: "organisation.record.branches",
      placement: {
        x: 3,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "organisation.record.locations.default",
      widgetId: "organisation.record.locations",
      placement: {
        x: 6,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "organisation.record.sales.default",
      widgetId: "organisation.record.sales",
      placement: {
        x: 9,
        y: 0,
        width: 3,
        height: 1,
      },
    },
    {
      id: "organisation.record.sales-trend.default",
      widgetId: "organisation.record.sales-trend",
      placement: {
        x: 0,
        y: 1,
        width: 6,
        height: 3,
      },
    },
    {
      id: "organisation.record.hiring-trend.default",
      widgetId: "organisation.record.hiring-trend",
      placement: {
        x: 6,
        y: 1,
        width: 6,
        height: 3,
      },
    },
  ],
};
